import lodashSet from 'lodash.set';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/redux/store';
import { questionnairesApi } from 'app/services/questionnaires';

export type TProperties = TProperty[];

export type TProperty = {
  addressOfProperty: Nullable<string>;
  currentFairMarketValue: Nullable<string>;
  purchasePrice: Nullable<string>;
  purchaseDate: Nullable<string>;
};

export interface OtherIncomeStateValues {
  properties: TProperties;
  pleaseNoteEverySingleQuestionOnThisPageAppliesToYouOrIfFilingJointlyBothYouAndYourSpouse: Nullable<string>;
  doYouOwnAShareinterestInACorporationOrPartnershipwhetherUsOrForeign: Nullable<TYesOrNo>;
  pleaseUploadSchK1OrForeignDocumentReportingYourShareOfIncomelosses: Nullable<string>;
  areYouTheSoleOwnerOfAUsLlc: Nullable<TYesOrNo>;
  pleaseUploadLlcRegistrationDocuments: Nullable<string>;
  whatIsTheEinOfTheLlc: Nullable<string>;
  doesTheLlcOwnUsRealProperty: Nullable<TYesOrNo>;
  areThesePropertiesUsedForRentalPurposes: Nullable<TYesOrNo>;
  cryptocurrencyDidYouReceiveSellExchangeOrOtherwiseAcquireAnyFinancialInterestInAnyVirtualCurrencyieBitcoin: Nullable<TYesOrNo>;
  pleaseReflectTheseTransactionsInTheInvestmentsSection: Nullable<string>;
  didYouReceiveAStipendOrFellowshipGrant: Nullable<TYesOrNo>;
  payorNameAndAddress: Nullable<string>;
  amountOfAward: Nullable<string>;
  currency: Nullable<string>;
  uploadAwardLetter: Nullable<string>;
  amountOfRelatedTravelAndTransportationExpensesifInResidenceFellow: Nullable<string>;
  didYouReceiveRoyalitieseitherUsOrForeign: Nullable<TYesOrNo>;
  pleaseUploadForm1099MiscOrForeignDocumentReportingRoyaltiesReceived: Nullable<string>;
  didYouReceiveARefundOrUnemploymentIncomeFromAUsStateInYear: Nullable<TYesOrNo>;
  pleaseUploadForm1099G: Nullable<string>;
  didYouPayOrReceiveAlimonyDuringYear: Nullable<string>;
  wasTheAlimonyPaymentreceiptMadeUnderADivorceOrSeparationAgreementEnteredIntoOnOrBeforeDec312018: Nullable<TYesOrNo>;
  amountAlimonyPaid: Nullable<string>;
  amount: Nullable<string>;
  recipientsName: Nullable<string>;
  recipientSs: Nullable<string>;
  didYouReceiveNonUsMonetaryBenefitsOfAnyKind: Nullable<string>;
  amountOfUnemploymentBenefitsYouReceived: Nullable<string>;
  pleaseUploadSupportingDocuments: Nullable<string>;
  doYouHaveACancelledieForgivenDuringTheYearDebtThatYouDidNotPayBack: Nullable<TYesOrNo>;
  pleaseUploadForm1099C: Nullable<string>;
  didYouFileBankruptcyAnyTimeInThePast: Nullable<string>;
  pleaseProvideDetails: Nullable<string>;
  didYouHaveLotterygamblingWinningOrLawsuitSettlementDuringTheFilingYear: Nullable<TYesOrNo>;
  didYouReceiveAnyEconomicImpactPaymentsLastYearcoronavirusStimulusPayment: Nullable<TYesOrNo>;
  didYouReceiveTheFirstStimulusOrBothStimulusPayments: Nullable<string>;
  firstGovernmentStimulusPackage: Nullable<string>;
  pleaseProvideTheAmountReceivedFromTheCoronavirusStimulusPayments: Nullable<string>;
  secondGovernmentStimulusPackage: Nullable<string>;
  haveYouReceivedChildBenefitsOfAnyKind: Nullable<TYesOrNo>;
  pleaseDescribeTheBenefitsYouveReceived: Nullable<string>;
  haveYouReceivedWelfareBenefits: Nullable<TYesOrNo>;
  welfareBenefitesThisIsNotUnemploymentInsurance: Nullable<string>;
  haveYouReceivedGovernmentHousingSubsidies: Nullable<TYesOrNo>;
  governmentHousingSubsidy: Nullable<string>;
  duringYearDidYouReceiveInheritanceOrGiftsFromANonUSPerson: Nullable<TYesOrNo>;
  duringYearDidYouReceiveInheritanceOrGiftsFromANonUSPersonProvideDetails: Nullable<string>;
  duringYearDidYouReceiveInheritanceOrGiftsFromANonUSPersonProvideDocument: Nullable<string>;
  didYouGiftAnyOnePersonOver$15k: Nullable<TYesOrNo>;
  originalDivorceSeparationAgreementDate: Nullable<string>;
  wereTheBenefitsProvidedByYourEmployerOrTheGovernment: Nullable<string>;
  pleaseSpecifyTheTypeOfBenefit: Nullable<string>;
  pleaseUploadSupportingDocumentsdidYouHaveLottery: Nullable<string>;
  pleaseProvideMoreDetailsdidYouHaveLottery: Nullable<string>;
  wereTheBenefitsProvidedByYourEmployerOrTheGovernmenthaveYouReceivedChildBenefitsOfAnyKind: Nullable<string>;
  didYouSellAnyCryptoCurrencyDuringTheYear: Nullable<TYesOrNo>;
}

export interface OtherIncomeState {
  values: OtherIncomeStateValues;
}

const initialState: OtherIncomeState = {
  values: {
    pleaseNoteEverySingleQuestionOnThisPageAppliesToYouOrIfFilingJointlyBothYouAndYourSpouse:
      null,
    doYouOwnAShareinterestInACorporationOrPartnershipwhetherUsOrForeign: null,
    pleaseUploadSchK1OrForeignDocumentReportingYourShareOfIncomelosses: null,
    areYouTheSoleOwnerOfAUsLlc: null,
    pleaseUploadLlcRegistrationDocuments: null,
    whatIsTheEinOfTheLlc: null,
    doesTheLlcOwnUsRealProperty: null,
    areThesePropertiesUsedForRentalPurposes: null,
    cryptocurrencyDidYouReceiveSellExchangeOrOtherwiseAcquireAnyFinancialInterestInAnyVirtualCurrencyieBitcoin:
      null,
    pleaseReflectTheseTransactionsInTheInvestmentsSection: null,
    didYouReceiveAStipendOrFellowshipGrant: null,
    payorNameAndAddress: null,
    amountOfAward: null,
    currency: null,
    uploadAwardLetter: null,
    amountOfRelatedTravelAndTransportationExpensesifInResidenceFellow: null,
    didYouReceiveRoyalitieseitherUsOrForeign: null,
    pleaseUploadForm1099MiscOrForeignDocumentReportingRoyaltiesReceived: null,
    didYouReceiveARefundOrUnemploymentIncomeFromAUsStateInYear: null,
    pleaseUploadForm1099G: null,
    didYouPayOrReceiveAlimonyDuringYear: null,
    wasTheAlimonyPaymentreceiptMadeUnderADivorceOrSeparationAgreementEnteredIntoOnOrBeforeDec312018:
      null,
    amountAlimonyPaid: null,
    amount: null,
    recipientsName: null,
    recipientSs: null,
    didYouReceiveNonUsMonetaryBenefitsOfAnyKind: null,
    amountOfUnemploymentBenefitsYouReceived: null,
    pleaseUploadSupportingDocuments: null,
    doYouHaveACancelledieForgivenDuringTheYearDebtThatYouDidNotPayBack: null,
    pleaseUploadForm1099C: null,
    didYouFileBankruptcyAnyTimeInThePast: null,
    pleaseProvideDetails: null,
    didYouHaveLotterygamblingWinningOrLawsuitSettlementDuringTheFilingYear:
      null,
    didYouReceiveAnyEconomicImpactPaymentsLastYearcoronavirusStimulusPayment:
      null,
    didYouReceiveTheFirstStimulusOrBothStimulusPayments: null,
    firstGovernmentStimulusPackage: null,
    pleaseProvideTheAmountReceivedFromTheCoronavirusStimulusPayments: null,
    secondGovernmentStimulusPackage: null,
    haveYouReceivedChildBenefitsOfAnyKind: null,
    pleaseDescribeTheBenefitsYouveReceived: null,
    haveYouReceivedWelfareBenefits: null,
    welfareBenefitesThisIsNotUnemploymentInsurance: null,
    haveYouReceivedGovernmentHousingSubsidies: null,
    governmentHousingSubsidy: null,
    duringYearDidYouReceiveInheritanceOrGiftsFromANonUSPerson: null,
    duringYearDidYouReceiveInheritanceOrGiftsFromANonUSPersonProvideDetails:
      null,
    duringYearDidYouReceiveInheritanceOrGiftsFromANonUSPersonProvideDocument:
      null,
    didYouGiftAnyOnePersonOver$15k: null,
    originalDivorceSeparationAgreementDate: null,
    wereTheBenefitsProvidedByYourEmployerOrTheGovernment: null,
    pleaseSpecifyTheTypeOfBenefit: null,
    pleaseUploadSupportingDocumentsdidYouHaveLottery: null,
    pleaseProvideMoreDetailsdidYouHaveLottery: null,
    wereTheBenefitsProvidedByYourEmployerOrTheGovernmenthaveYouReceivedChildBenefitsOfAnyKind:
      null,
    properties: [
      {
        addressOfProperty: null,
        currentFairMarketValue: null,
        purchasePrice: null,
        purchaseDate: null,
      },
    ],
    didYouSellAnyCryptoCurrencyDuringTheYear: null,
  },
};

const otherIncomeSlice = createSlice({
  name: 'otherIncome',
  initialState,
  reducers: {
    update(state, action: PayloadAction<OtherIncomeStateValues>) {
      state.values = JSON.parse(JSON.stringify(action.payload));
    },
    updateKey(
      state,
      action: PayloadAction<{
        key: keyof OtherIncomeStateValues | keyof TProperty;
        value: any;
      }>,
    ) {
      lodashSet(state, `values.${action.payload.key}`, action.payload.value);
    },
    updateFieldArrayKey(
      state,
      action: PayloadAction<{
        key: keyof OtherIncomeStateValues | keyof TProperty;
        value: TProperties;
      }>,
    ) {
      const fieldArray = action.payload.value.map((field) => ({ ...field }));
      if (action.payload.key === 'properties') {
        state.values[action.payload.key] = fieldArray;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      questionnairesApi.endpoints.getQuestionnaireById.matchFulfilled,
      (state, { payload }) => {
        state.values = payload.questionnaire.data.taxQuestionnaire
          ? payload.questionnaire.data.taxQuestionnaire.income.otherIncome
              .values
          : initialState.values;
      },
    );
  },
});

export const { update, updateKey, updateFieldArrayKey } =
  otherIncomeSlice.actions;
export default otherIncomeSlice.reducer;

export const selectOtherIncome = (state: RootState) =>
  state.taxQuestionnaire.income.otherIncome;
